<template>
    <div class="billing-period-container">
        <div class="billing-period-button" v-for="(period, key) in periods" :key="key"
            :class="{ active: key === value, 'has-active': key !== 'monthly' && getActivePlanCount(key) > 0 }" @click="$emit('input', key)">
            <span v-if="key !== 'monthly' && getActivePlanCount(key) > 0" class="active-plan-badge">
                {{ $t("billing.activePlansCount", { count: getActivePlanCount(key) }) }}
            </span>
            {{ period }}
            <span v-if="discount[key] > 0" class="discount-badge">{{ discount[key] }}%</span>
        </div>
    </div>
</template>
<script>
export default {
    name: "PlanPeriods",
    props: {
        value: {
            type: String,
            default: "monthly",
        },
        currentPlans: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            periods: {
                monthly: this.$t("billing.monthly"),
                "monthly-3": this.$t("billing.threeMonthly"),
                "monthly-6": this.$t("billing.sixMonthly"),
                annual: this.$t("billing.yearly"),
                "annual-2": this.$t("billing.twoYearDiscount"),
            },
            discount: {
                monthly: 0,
                "monthly-3": 5,
                "monthly-6": 10,
                annual: 20,
                "annual-2": 30,
            },
        };
    },
    methods: {
        /**
         * Belirli bir period için aktif plan sayısını hesaplar
         * @param {String} period - Period key'i (monthly, annual, vb.)
         * @returns {Number} Aktif plan sayısı
         */
        getActivePlanCount(period) {
            if (!this.currentPlans || this.currentPlans.length === 0) {
                return 0;
            }

            return this.currentPlans.filter(plan => plan.period === period).length;
        },
    },
};
</script>
<style lang="scss" scoped>
.billing-period-container {
    display: flex;
    align-items: center;
    padding: 4px;
    border-radius: 6px;
    background-color: #f7f9fc;
    gap: 8px;

    .billing-period-button {
        padding: 8px 16px;
        border-radius: 6px;
        cursor: pointer;
        font-size: 14px;
        display: flex;
        align-items: center;
        height: 40px;
        min-width: 130px;
        gap: 6px;
        color: #333;
        font-weight: 600;
        background-color: #ffffff;
        border: 1px solid #ddd;
        transition: all 0.2s ease-in-out;
        position: relative;
        justify-content: center;


        .discount-badge {
            color: #ffffff;
            font-size: 12px;
            background: #f79d65;
            border-radius: 4px;
            padding: 2px 6px;
            font-weight: bold;
        }

        .active-plan-badge {
            position: absolute;
            top: -28px;
            left: -1px;
            font-size: 10px;
            font-weight: 500;
            border-radius: 8px 8px 0 0;
            border: 1px dotted #f69d65;
            padding: 3px 10px;
            display: flex;
            align-items: center;
            justify-content: center;
            white-space: nowrap;
            background: white;
            color: #f69d65;
            border-bottom: 0px;
            border-bottom-right-radius: 0;
            border-bottom-left-radius: 0;
        }

        &:hover {
            background: #fd8544;
            color: #ffffff;
            border-color: #f79d65;
            box-shadow: 0 2px 6px rgba(138, 53, 0, 0.15);
        }

        &.active {
            background: #f79d65;
            color: #ffffff;
            border-color: #f79d65;

            .discount-badge {
                background: #ffe6d5;
                color: #f07935;
            }
        }

        &.has-active {
            border-top-left-radius: 0;
        }
    }
}
</style>
